/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationwinsperdayrequired5Inputs */

const en_dropvalidationwinsperdayrequired5 = /** @type {(inputs: Dropvalidationwinsperdayrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter how many prizes go out per day (1 to 1,000).`)
};

const de_dropvalidationwinsperdayrequired5 = /** @type {(inputs: Dropvalidationwinsperdayrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib an, wie viele Preise pro Tag rausgehen (1 bis 1.000).`)
};

/**
* | output |
* | --- |
* | "Enter how many prizes go out per day (1 to 1,000)." |
*
* @param {Dropvalidationwinsperdayrequired5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationwinsperdayrequired5 = /** @type {((inputs?: Dropvalidationwinsperdayrequired5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationwinsperdayrequired5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationwinsperdayrequired5(inputs)
	return de_dropvalidationwinsperdayrequired5(inputs)
});
export { dropvalidationwinsperdayrequired5 as "dropValidationWinsPerDayRequired" }